// Kids Conference theming.
//
// The Kids module is the same app reskinned teal, themed BY CONTEXT (active
// department/route) rather than by user — so a person who serves both sees teal
// in their Kids areas and the existing dark theme everywhere else.
//
// Implementation is an additive, scoped CSS override: when a Kids context is
// active we add the `theme-kids` class to the shell/page wrapper, and the
// `.theme-kids …` rules in index.css retint the dark primary surfaces (sidebar)
// to teal. Body/heading text is intentionally left untouched.

export const KIDS_DEPARTMENT = 'Kids';
export const KIDS_THEME_CLASS = 'theme-kids';

export function isKidsDepartment(department) {
  return (department || '').toString().trim().toLowerCase() === 'kids';
}

// True when a team object belongs to the Kids department.
export function isKidsTeam(team) {
  return !!team && isKidsDepartment(team.department);
}

// Returns the wrapper class string to append when `active` is true.
export function kidsThemeClass(active) {
  return active ? ` ${KIDS_THEME_CLASS}` : '';
}
